var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_11461_1121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29884 17.3445C4.78915 14.7296 4.38004 11.6221 5.16152 8.70564C5.94299 5.78915 7.85103 3.30254 10.4659 1.79285C13.0807 0.283162 16.1882 -0.125945 19.1047 0.655527C22.0212 1.437 24.5078 3.34504 26.0175 5.9599L20.4896 9.15144C19.8264 8.00268 18.7339 7.16444 17.4527 6.82112C16.1714 6.4778 14.8062 6.65753 13.6574 7.32077C12.5087 7.98401 11.6704 9.07643 11.3271 10.3577C10.9838 11.639 11.1635 13.0042 11.8268 14.1529L6.29884 17.3445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0976 14.9158C21.6073 17.5306 22.0164 20.6381 21.2349 23.5546C20.4534 26.4711 18.5454 28.9577 15.9305 30.4674C13.3157 31.9771 10.2082 32.3862 7.2917 31.6047C4.3752 30.8232 1.8886 28.9152 0.378906 26.3003L5.90682 23.1088C6.57006 24.2575 7.66248 25.0958 8.94376 25.4391C10.225 25.7824 11.5902 25.6027 12.739 24.9395C13.8877 24.2762 14.726 23.1838 15.0693 21.9025C15.4126 20.6212 15.2329 19.2561 14.5697 18.1073L20.0976 14.9158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_11461_1121",
    x: 0.378906,
    y: -0.746915,
    width: 25.6387,
    height: 33.7541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.01449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11461_1121"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.01449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11461_1121",
    result: "effect2_innerShadow_11461_1121"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9af1fae42a84d57660738ef24294dffd.svg";
export { ForwardRef as ReactComponent };